import ptBrLocale from 'date-fns/locale/pt-BR';
import enUsLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';
import { responseMessages } from './serverMessages';
import { yup } from 'src/utils/definitionsYup';

import { enUS, esES, ptBR, frFR } from '@mui/x-date-pickers/locales';

export const locale = {
    en: enUsLocale,
    es: esLocale,
    pt: ptBrLocale,
    fr: frLocale,
}

export const dateLocale = {
    en: enUS,
    es: esES,
    pt: ptBR,
    fr: frFR,
}

export const supportedLanguages = {
    en: 'English',
    es: 'Español',
    pt: 'Português',
    fr: 'Français',
};

const invites = {
    en: {
        expires: 'Expires on',
        issuedOn: 'Issued',
        inviteHeader: 'The following invites will be ',
        provisionHandles: 'Provision User Handles',
        invites: 'Invites',
        inviteType: 'Invite Type',
        inviteInfo: 'Provide Invite Details',
        completeInvite: 'Finalize Invite',
        sendAnotherInvite: 'Send Another Invite',
        inviteLanguage: 'Choose Invite Language',
        chosenInviteLanguage: 'Chosen Invite Language',
        matchUser: 'Require that users can only register with the email address to which the invite was sent',
        matchUserNegative: 'Users can sign-up with any e-mail address',
        directSigninTag: 'Automatic Sign-in',
        directSignin: 'Automatically sign-in users when their invite has been approved',
        directSigninNotice: 'If selected, invited users will have to enter the code received on the invite email in the Create Account Form on the app',
        directSigninNegative: 'Invited users will have to verify their e-mail accounts before signing in',
        enterEmails: 'Enter email address(es), one per line',
        enterHandles: 'Enter usernames, one per line',
        processList: 'Process List',
        startOver: 'Start Over',
        processed: 'Processed',
        validEmails: 'valid e-mails',
        validHandles: 'valid handles',
        notEnoughLicenses: 'Not enough available licenses - Reduce number of invites',
        reviewAndSend: 'Review and Send',
        reviewAndProvision: 'Review and Provision',
        reviewInvite: 'Review your invite',
        sendInvites: 'Send Invites',
        typeOfInvite: 'How would you like to onboard users?',
        sendInvitesViaEmail: 'Send Invites via e-mail',
        viaEmailDescription: '<b>Send Invites via e-mail</b><br />Users will receive an e-mail with a code.',
        viaHandleProvisioning: '<b>Provision User Handles</b><br />Define a list of pre-approved user handles.',
        assignedTeam: 'Assigned Company: ',
        assignedLicense: 'Available license packs',
        listOfEmailsToBeInvited: 'List of Invited User E-mails',
        listOfHandlesToBeInvited: 'List of Invited User Handles',
        handle: 'User Handle',
        teamSlugNotice: 'User Handles will incorporate the company identifier',
        code: 'Code',
        match: 'Match',
        resendInvite: 'Resend Invite',
        inviteDelete: 'deleted',
        inviteResend: 'resent',
    },
    pt: {
        expires: 'Expira em',
        issuedOn: 'Enviado',
        inviteHeader: 'Os seguintes convites serão ',
        inviteDelete: 'removidos',
        inviteResend: 'reenviados',
        match: 'Correspondência',
        code: 'Código',
        provisionHandles: 'Provisionar Identificador de Usuário',
        invites: 'Convites',
        inviteType: 'Tipo de Convite',
        inviteInfo: 'Informações do Convite',
        completeInvite: 'Finalizar Convite',
        sendAnotherInvite: 'Enviar Outro Convite',
        inviteLanguage: 'Escolha a Língua do Convite',
        chosenInviteLanguage: 'Língua Escolhida',
        matchUser: 'Exigir que o e-mail do convite seja o mesmo que das contas criadas',
        matchUserNegative: 'Usuários podem se cadastrar com qualquer e-mail',
        directSigninTag: 'Acesso automático',
        directSignin: 'Usuários convidados poderão acessar diretamente sua conta após criação',
        directSigninNotice: 'Se selecionado, os usuários deverão inserir o código recebido no email de convite no formulário de criação de conta no app',
        directSigninNegative: 'Todos usuários deverão verificar suas contas de e-mail',
        enterEmails: 'Digite a sua lista de e-mails convidados (um por linha)',
        enterHandles: 'Digite sua lista de identificadores convidados (um por linha)',
        processList: 'Processar Lista',
        startOver: 'Recomeçar',
        processed: 'Processados',
        validEmails: 'valid e-mails',
        validHandles: 'identificadores válidos',
        notEnoughLicenses: 'Não há licensas disponíveis suficientes - Reduza o número de convites',
        reviewAndSend: 'Revisar e Enviar',
        reviewAndProvision: 'Revisar e Provisionar',
        sendInvites: 'Mandar Convites',
        reviewInvite: 'Revise seu convite',
        typeOfInvite: 'Como você gostaria de convidar usuários?',
        sendInvitesViaEmail: 'Mandar convites via e-mail',
        viaEmailDescription: '<b>Send Invites via e-mail</b><br />Users will receive an e-mail with a code.',
        viaHandleProvisioning: '<b>Provision User Handles</b><br />Define a list of pre-approved user handles.',
        assignedTeam: 'Time escolhido: ',
        assignedLicense: 'Pacote de licença disponíveis',
        listOfEmailsToBeInvited: 'Lista de E-mails de Usuários Convidados',
        listOfHandlesToBeInvited: 'Lista de Identificadores de Usuário Convidados',
        handle: 'Identificador de Usuário',
        teamSlugNotice: 'Os Identificadores de Usuário incorporarão o identificador do time',
        resendInvite: 'Re-enviar Convite',
    },
    es: {
        expires: 'Expira el',
        issuedOn: 'Enviado',
        inviteHeader: 'Las siguientes invitaciones serán ',
        provisionHandles: 'Provisión de identificadores de usuario',
        invites: 'Invitaciones',
        inviteType: 'Tipo de invitación',
        inviteInfo: 'Información de la invitación',
        completeInvite: 'Completar invitación',
        sendAnotherInvite: 'Enviar otra invitación',
        inviteLanguage: 'Elegir idioma de la invitación',
        chosenInviteLanguage: 'Idioma elegido para la invitación',
        matchUser: 'Los usuarios invitados deben crear cuentas que coincidan con su dirección de invitación',
        matchUserNegative: 'Los usuarios pueden registrarse con cualquier dirección de correo electrónico',
        directSigninTag: 'Inicio de sesión automático',
        directSignin: 'Los usuarios invitados iniciarán sesión automáticamente después de crear la cuenta',
        directSigninNotice: 'Si es seleccionado, los usuarios deberán ingresar el código recibido en el correo de invitación en el formulario de creación de cuenta en la aplicación',
        directSigninNegative: 'Los usuarios invitados deberán verificar sus cuentas de correo electrónico antes de iniciar sesión',
        enterEmails: 'Escriba su lista de correos electrónicos invitados (uno por línea)',
        enterHandles: 'Escriba su lista de identificadores invitados (uno por línea)',
        processList: 'Procesar lista',
        startOver: 'Empezar de nuevo',
        processed: 'Procesado',
        validEmails: 'correos electrónicos válidos',
        validHandles: 'identificadores válidos',
        notEnoughLicenses: 'No hay suficientes licencias disponibles - Reduzca el número de invitaciones',
        reviewAndSend: 'Revisar y enviar',
        reviewAndProvision: 'Revisar y proveer',
        reviewInvite: 'Revisar su invitación',
        sendInvites: 'Enviar invitaciones',
        typeOfInvite: '¿Cómo le gustaría incorporar a los usuarios?',
        sendInvitesViaEmail: 'Enviar invitaciones por correo electrónico',
        viaEmailDescription: '<b>Enviar invitaciones por correo electrónico</b><br />Los usuarios recibirán un correo electrónico con un código.',
        viaHandleProvisioning: '<b>Provisión de identificadores de usuario</b><br />Defina una lista de identificadores de usuario preaprobados.',
        assignedTeam: 'Equipo asignado: ',
        assignedLicense: 'Paquete de licencias disponibles',
        listOfEmailsToBeInvited: 'Lista de correos electrónicos de usuarios invitados',
        listOfHandlesToBeInvited: 'Lista de identificadores de usuario invitados',
        handle: 'Identificador de usuario',
        teamSlugNotice: 'Los identificadores de usuario incorporarán el identificador del equipo',
        code: 'Código',
        match: 'Coincidencia',
        resendInvite: 'Reenviar invitación',
        inviteDelete: 'eliminada',
        inviteResend: 'reenviada',
    },
    fr: {
        expires: 'Expire le',
        issuedOn: 'Envoyé',
        inviteHeader: 'Les invitations suivantes seront ',
        provisionHandles: 'Provision d\'identifiants utilisateur',
        invites: 'Invitations',
        inviteType: 'Type d\'invitation',
        inviteInfo: 'Détails de l\'invitation',
        completeInvite: 'Finaliser l\'invitation',
        sendAnotherInvite: 'Envoyer une autre invitation',
        inviteLanguage: 'Choisir la langue de l\'invitation',
        chosenInviteLanguage: 'Langue d\'invitation choisie',
        matchUser: 'Exiger que les utilisateurs ne puissent s\'inscrire qu\'avec l\'adresse e-mail à laquelle l\'invitation a été envoyée',
        matchUserNegative: 'Les utilisateurs peuvent s\'inscrire avec n\'importe quelle adresse e-mail',
        directSigninTag: 'Connexion automatique',
        directSignin: 'Connecter automatiquement les utilisateurs lorsque leur invitation a été approuvée',
        directSigninNotice: 'Si sélectionné, les utilisateurs invités devront saisir le code reçu dans l\'e-mail d\'invitation dans le formulaire de création de compte de l\'application',
        directSigninNegative: 'Les utilisateurs invités devront vérifier leurs comptes e-mail avant de se connecter',
        enterEmails: 'Saisissez les adresses e-mail, une par ligne',
        enterHandles: 'Saisissez les noms d\'utilisateur, un par ligne',
        processList: 'Traiter la liste',
        startOver: 'Recommencer',
        processed: 'Traités',
        validEmails: 'e-mails valides',
        validHandles: 'identifiants valides',
        notEnoughLicenses: 'Pas assez de licences disponibles - Réduisez le nombre d\'invitations',
        reviewAndSend: 'Réviser et envoyer',
        reviewAndProvision: 'Réviser et provisionner',
        reviewInvite: 'Réviser votre invitation',
        sendInvites: 'Envoyer des invitations',
        typeOfInvite: 'Comment souhaitez-vous intégrer les utilisateurs ?',
        sendInvitesViaEmail: 'Envoyer des invitations par e-mail',
        viaEmailDescription: '<b>Envoyer des invitations par e-mail</b><br />Les utilisateurs recevront un e-mail avec un code.',
        viaHandleProvisioning: '<b>Provision d\'identifiants utilisateur</b><br />Définir une liste d\'identifiants utilisateur pré-approuvés.',
        assignedTeam: 'Entreprise assignée : ',
        assignedLicense: 'Packs de licences disponibles',
        listOfEmailsToBeInvited: 'Liste des e-mails d\'utilisateurs invités',
        listOfHandlesToBeInvited: 'Liste des identifiants d\'utilisateurs invités',
        handle: 'Identifiant utilisateur',
        teamSlugNotice: 'Les identifiants utilisateur incorporeront l\'identifiant de l\'entreprise',
        code: 'Code',
        match: 'Correspondance',
        resendInvite: 'Renvoyer l\'invitation',
        inviteDelete: 'supprimée',
        inviteResend: 'renvoyée',
    }
}

const domains = {
    en: {
        domainWhitelist: 'Domain Whitelist',
        createDomainAssociation: 'Register Domain',
        registerDomainAssociations: 'Register Associations',
        manageDomains: 'Manage Team-Domain Associations',
        editDomainAssociation: 'Edit Domain Associations',
        domains: 'Domains',
        domain: 'Domain',
        domainList: 'Domain Associations',
        noDomainsRegistered: 'No domains have been registered for this team',
        enterDomain: 'Enter your domain',
        deleteAllDomainsForTeam: 'All domains registered to the following team will be',
        domainsAssociatedWith: 'Domains associated with team',
    },
    pt: {
        domainWhitelist: 'Domínios Aprovados',
        createDomainAssociation: 'Registrar Domínio',
        registerDomainAssociations: 'Registrar Associações',
        manageDomains: 'Gerenciar Associações Time-Domínio',
        editDomainAssociation: 'Editar Associações com Domínios',
        domain: 'Domínio',
        domains: 'Domínios',
        domainList: 'Associação de Domínios',
        noDomainsRegistered: 'Nenhum domínio foi registrado para este time',
        enterDomain: 'Digite seu domínio',
        deleteAllDomainsForTeam: 'Todos domínios registrados para o time abaixo serão',
        domainsAssociatedWith: 'Domínios associados com time',
    },
    es: {
        domainWhitelist: 'Lista blanca de dominios',
        createDomainAssociation: 'Registrar dominio',
        registerDomainAssociations: 'Registrar asociaciones',
        manageDomains: 'Gestionar asociaciones equipo-dominio',
        editDomainAssociation: 'Editar asociaciones con dominios',
        domains: 'Dominios',
        domain: 'Dominio',
        domainList: 'Asociaciones de dominio',
        noDomainsRegistered: 'No se han registrado dominios para este equipo',
        enterDomain: 'Escriba su dominio',
        deleteAllDomainsForTeam: 'Todos los dominios registrados para el siguiente equipo serán',
        domainsAssociatedWith: 'Dominios asociados con el equipo',
    },
    fr: {
        domainWhitelist: 'Liste blanche des domaines',
        createDomainAssociation: 'Enregistrer le domaine',
        registerDomainAssociations: 'Enregistrer les associations',
        manageDomains: 'Gérer les associations équipe-domaine',
        editDomainAssociation: 'Modifier les associations de domaine',
        domains: 'Domaines',
        domain: 'Domaine',
        domainList: 'Associations de domaine',
        noDomainsRegistered: 'Aucun domaine n\'a été enregistré pour cette équipe',
        enterDomain: 'Saisissez votre domaine',
        deleteAllDomainsForTeam: 'Tous les domaines enregistrés pour l\'équipe suivante seront',
        domainsAssociatedWith: 'Domaines associés à l\'équipe',
    }
}

const licenses = {
    en: {
        manageStripeSub: 'Manage Stripe Subscription',
        manageExistingSub: 'Manage existing subscriptions',
        subscription: 'Subscription',
        distributeLicenses: 'Distribute licenses',
        activateLicenseFill: 'Please copy and paste the license token provided to you',
        noLicensesAvailable: 'No Licenses Available',
        createLicenses: 'Create new license packs',
        licenses: 'Licences',
        license: 'License',
        licenseID: 'License ID',
        licenseType: 'Type',
        extendLicense: 'Extend License Pack',
        expireLicense: 'Expire License Pack',
        licenseStatus: 'License Status',
        licenseExpired: 'Licence Expired',
        subscriptionExpired: "Expired",
        licenseExpiration: 'Licence Expiration',
        licenseActivateToken: 'Activate Licenses',
        licenseChose: 'Choose license pack',
        licenseCount: 'Choose number of licenses',
        licenseExtend: '# of days from today',
        licenseValid: 'Valid license',
        licenseNearExpiration: 'License about to expire',
        subscriptionValid: 'Active',
        licenseValidUntil: 'License valid until',
        licenseUnlimited: 'Unlimited',
        unlicensed: 'Unlicensed',
        licenseGauge: 'Users / Invites / Available',
        licenseHeader: 'The following license will be ',
        identifier: 'Identifier',
        currentLicense: '{licenseId} (Current)',
        licenseUsage: '{licenseId} ({used} used of {total})',
    },
    pt: {
        manageExistingSub: 'Gerenciar assinaturas existentes',
        manageStripeSub: 'Gerenciar Assinatura Stripe',
        subscription: 'Assinatura',
        distributeLicenses: 'Distribua as licenças',
        activateLicenseFill: 'Por favor, copie e cole o token de licença fornecido a você',
        noLicensesAvailable: 'Nenhuma Licença Disponível',
        createLicenses: 'Criar novos pacotes de licença',
        licenses: 'Licenças',
        license: 'Licença',
        licenseID: 'ID',
        licenseType: 'Tipo',
        licenseStatus: 'Status de Licenças',
        licenseActivateToken: 'Ativar Licenças',
        licenseExpired: 'Licença expirada',
        subscriptionExpired: "Expirada",
        licenseExpiration: 'Expiração da Licença',
        licenseValid: 'Licença válida',
        subscriptionValid: 'Ativa',
        licenseChose: 'Escolher pacote de licença',
        licenseCount: 'Escolher quantidade de licenças',
        licenseExtend: '# de dias a partir de hoje',
        extendLicense: 'Extender pacote de licença',
        expireLicense: 'Expirar pacote de licença',
        licenseNearExpiration: 'Licença perto de expirar',
        licenseValidUntil: 'Licença válida até',
        licenseUnlimited: 'Ilimitada',
        unlicensed: 'Sem licenças',
        licenseGauge: 'Usuários / Convites / Disponível',
        licenseHeader: 'A seguinte licença será',
        identifier: 'Identificador',
        currentLicense: '{licenseId} (Atual)',
        licenseUsage: '{licenseId} ({used} usadas de {total})',
    },
    es: {
        manageExistingSub: 'Gestionar suscripciones existentes',
        manageStripeSub: 'Gestionar Suscripción de Stripe',
        subscription: 'Suscripción',
        distributeLicenses: 'Distribuya las licencias',
        activateLicenseFill: 'Por favor, copie y pegue el token de licencia que se le proporcionó',
        noLicensesAvailable: 'No hay licencias disponibles',
        createLicenses: 'Crear nuevos paquetes de licencias',
        licenses: 'Licencias',
        license: 'Licencia',
        licenseID: 'ID de licencia',
        licenseType: 'Tipo',
        extendLicense: 'Estender paquete de licencias',
        expireLicense: 'Expirar paquete de licencias',
        licenseStatus: 'Estado de la licencia',
        licenseExpired: 'Licencia expirada',
        subscriptionExpired: "Expirada",
        licenseExpiration: 'Expiración de la licencia',
        licenseActivateToken: 'Activar licencias',
        licenseChose: 'Elegir paquete de licencia',
        licenseCount: 'Elegir número de licencias',
        licenseExtend: '# de dias a partir de oje',
        licenseValid: 'Licencia válida',
        licenseNearExpiration: 'Licencia a punto de expirar',
        subscriptionValid: 'Ativa',
        licenseValidUntil: 'Licencia válida hasta',
        licenseUnlimited: 'Ilimitada',
        unlicensed: 'Sin licencia',
        licenseGauge: 'Usuarios / Invitaciones / Disponibles',
        licenseHeader: 'La siguiente licencia será ',
        identifier: 'Identificador',
        currentLicense: '{licenseId} (Actual)',
        licenseUsage: '{licenseId} ({used} usadas de {total})',
    },
    fr: {
        manageStripeSub: 'Gérer l\'abonnement Stripe',
        manageExistingSub: 'Gérer les abonnements existants',
        subscription: 'Abonnement',
        distributeLicenses: 'Distribuer les licences',
        activateLicenseFill: 'Veuillez copier et coller le jeton de licence qui vous a été fourni',
        noLicensesAvailable: 'Aucune licence disponible',
        createLicenses: 'Créer de nouveaux packs de licences',
        licenses: 'Licences',
        license: 'Licence',
        licenseID: 'ID de licence',
        licenseType: 'Type',
        extendLicense: 'Étendre le pack de licences',
        expireLicense: 'Faire expirer le pack de licences',
        licenseStatus: 'Statut de la licence',
        licenseExpired: 'Licence expirée',
        subscriptionExpired: 'Expiré',
        licenseExpiration: 'Expiration de la licence',
        licenseActivateToken: 'Activer les licences',
        licenseChose: 'Choisir le pack de licences',
        licenseCount: 'Choisir le nombre de licences',
        licenseExtend: '# de jours à partir d\'aujourd\'hui',
        licenseValid: 'Licence valide',
        licenseNearExpiration: 'Licence sur le point d\'expirer',
        subscriptionValid: 'Actif',
        licenseValidUntil: 'Licence valide jusqu\'au',
        licenseUnlimited: 'Illimitée',
        unlicensed: 'Sans licence',
        licenseGauge: 'Utilisateurs / Invitations / Disponibles',
        licenseHeader: 'La licence suivante sera ',
        identifier: 'Identifiant',
        currentLicense: '{licenseId} (Actuel)',
        licenseUsage: '{licenseId} ({used} utilisées sur {total})',
    }
}

const teams = {
    en: {
        showContactList: 'Display team contact list',
        teamName: 'Company name',
        noTeamsAvailable: 'No Companies Available',
        noUsersAvailable: 'No Users Available',
        teamAndLicense: 'Company and License',
        teamAndLicense2: 'Select Company and License',
        slug: 'Identifier',
        azureAD: 'Azure AD Synchronization',
        certRevocationStrategy: 'Strategy for Checking a Certificate\'s Revocation Status',
        ocsp_only: 'OCSP Only',
        ocsp_crl: 'OCSP and CRL',
        disabledOCSP: 'Disabled (for debugging)',
        editTeamMembership: 'Edit Company Membership',
        editTeamTitle: 'Company Membership',
        editTeamSelect: 'Select companies',
        teamSettings: 'Company Custom Settings',
        editDefaultSettings: 'Click on the checkboxes below to override the default system settings',
        noTeamAdmin: 'This company is not currently managed by any administrator!',
        oauthClientID: 'OAuth client ID',
        oauthAuthority: 'OAuth authority',
        oauthDiscovery: 'OAuth discovery',
        oauthVersion: 'OAuth version',
        oauthTenantID: 'OAuth tenant ID',
        emailTheme: 'E-mail theme',
    },
    pt: {
        showContactList: 'Exibir contatos de equipe',
        teamName: 'Nome do time',
        noTeamsAvailable: 'Nenhum Time Disponível',
        noUsersAvailable: 'Nenhum Usuário Disponível',
        teamAndLicense: 'Time e Licença',
        teamAndLicense2: 'Selecione Time e Licença',
        slug: 'Identificador',
        azureAD: 'Sincronização com Azure AD',
        certRevocationStrategy: 'Estratégia para checar o status de revogação de um certificado',
        ocsp_only: 'Apenas OCSP',
        ocsp_crl: 'OCSP e CRL',
        disabledOCSP: 'Desabilitado (para debugging)',
        editTeamMembership: 'Editar Acesso a Times',
        editTeamTitle: 'Acesso a times',
        editTeamSelect: 'Selecione times',
        teamSettings: 'Configurações Personalizadas do time',
        editDefaultSettings: 'Clique nas caixas abaixo para redefinir os padrões do sistema',
        noTeamAdmin: 'Este time atualmente não é gerenciado por nenhum administrador!',
        oauthClientID: 'OAuth client ID',
        oauthAuthority: 'OAuth authority',
        oauthDiscovery: 'OAuth discovery',
        oauthVersion: 'OAuth version',
        oauthTenantID: 'OAuth tenant ID',
        emailTheme: 'Tema dos E-mails',
    },
    es: {        
        showContactList: 'Mostrar contactos del equipo',
        teamName: 'Nombre del equipo',
        noTeamsAvailable: 'No hay equipos disponibles',
        noUsersAvailable: 'No hay usuarios disponibles',
        teamAndLicense: 'Equipo y licencia',
        teamAndLicense2: 'Seleccionar nuevo equipo o licencia',
        slug: 'Identificador',
        azureAD: 'Sincronización con Azure AD',
        certRevocationStrategy: 'Estrategia para comprobar el estado de revocación del certificado',
        ocsp_only: 'Solo OCSP',
        ocsp_crl: 'OCSP y CRL',
        disabledOCSP: 'Deshabilitado (para depuración)',
        editTeamMembership: 'Editar membresía del equipo',
        editTeamTitle: 'Membresía del equipo',
        editTeamSelect: 'Seleccionar equipos',
        teamSettings: 'Configuraciones personalizadas del equipo',
        editDefaultSettings: 'Haga clic en las casillas a continuación para sobrescribir las configuraciones predeterminadas del sistema',
        noTeamAdmin: '¡Este equipo no es gestionado actualmente por ningún administrador!',
        oauthClientID: 'OAuth client ID',
        oauthAuthority: 'OAuth authority',
        oauthDiscovery: 'OAuth discovery',
        oauthVersion: 'OAuth version',
        oauthTenantID: 'OAuth tenant ID',
        emailTheme: 'E-mail theme',
    },
    fr: {
        showContactList: 'Afficher la liste des contacts de l\'équipe',
        teamName: 'Nom de l\'entreprise',
        noTeamsAvailable: 'Aucune entreprise disponible',
        noUsersAvailable: 'Aucun utilisateur disponible',
        teamAndLicense: 'Entreprise et licence',
        teamAndLicense2: 'Sélectionner l\'entreprise et la licence',
        slug: 'Identifiant',
        azureAD: 'Synchronisation Azure AD',
        certRevocationStrategy: 'Stratégie de vérification du statut de révocation d\'un certificat',
        ocsp_only: 'OCSP seulement',
        ocsp_crl: 'OCSP et CRL',
        disabledOCSP: 'Désactivé (pour le débogage)',
        editTeamMembership: 'Modifier l\'appartenance à l\'entreprise',
        editTeamTitle: 'Appartenance à l\'entreprise',
        editTeamSelect: 'Sélectionner les entreprises',
        teamSettings: 'Paramètres personnalisés de l\'entreprise',
        editDefaultSettings: 'Cliquez sur les cases ci-dessous pour remplacer les paramètres système par défaut',
        noTeamAdmin: 'Cette entreprise n\'est actuellement gérée par aucun administrateur !',
        oauthClientID: 'ID client OAuth',
        oauthAuthority: 'Autorité OAuth',
        oauthDiscovery: 'Découverte OAuth',
        oauthVersion: 'Version OAuth',
        oauthTenantID: 'ID tenant OAuth',
        emailTheme: 'Thème des e-mails',
    }
}

const users = {
    en: {
        appVersion: 'App version',
        os: 'Operating System',
        osVersion: 'OS Version',
        searchBy: 'Search by name or username',
        reInvited: 're-invited',
        resendInvite: 'Re-send invite',
        thirdPartyNiapDevice: 'Third-party SIP user',
        cellcryptApp: 'Cellcrypt device',
        terminateAcctHeader: 'Are you sure you want to terminate your account?',
        terminateAcctWarning: 'This action cannot be undone. You will be signed out automatically.',
        usersHeader: 'The following users will be ',
        userCreateTeamError: 'You must choose a company with available licenses',
        users: 'Users',
        manageUsers: 'Manage Users',
        userProfile: 'User Profile',
        usersCreate: 'Create Users',
        usersCreated: 'User created at',
        userCreate: 'Create User',
        usersList: 'List Users',
        userInfo: 'User Information',
        generateStrongPassword: 'Generate Strong Password',
        deviceWiped: 'Device Wiped!',
        aliases: 'Aliases',
        devices: 'Devices',
        remoteWipe: 'Remotely Wipe Device',
        remoteWiped: 'remotely wiped',
        noDevicesAvailable: 'No devices available',
        ecs: 'Enterprise Communication System User',
        emailOrIdentifier: 'E-mail or User Identifier',
        plan: 'Plan',
        noSubscription: 'No subscription',
        planPersonal: 'Personal',
        planPro: 'Pro',
        planGroup: 'Group',
        planFree: 'Free',
        subActive: 'Active',
        subCanceled: 'Canceled',
        subGrace: 'Grace period',
        subOnHold: 'On hold',
        subPaused: 'Paused',
        subExpired: 'Expired',
        subRevoked: 'Revoked',
        subPending: 'Pending',
        subUnknown: 'Unknown',
    },
    pt: {
        appVersion: 'Versão do app',
        os: 'Sistema Operacional',
        osVersion: 'Versão do SO',
        searchBy: 'Procure por um nome ou identificador',
        users: 'Usuários',
        reInvited: 'convidados novamente',
        resendInvite: 'Re-enviar convite',
        thirdPartyNiapDevice: 'Usuário de Dispositivo SIP',
        cellcryptApp: 'Dispostivo Cellcrypt',
        terminateAcctHeader: 'Você tem certeza que deseja encerrar sua conta?',
        terminateAcctWarning: 'Essa ação não pode ser desfeita. Sua sessão será terminada imediatamente.',
        usersHeader: 'Os seguintes usuários serão',
        userCreateTeamError: 'Você deve escolher um time com licenças disponíveis!',
        manageUsers: 'Gerenciar usuários',
        userProfile: 'Perfil de usuário',
        usersCreate: 'Criar usuários',
        usersCreated: 'Criado em',
        userCreate: 'Criar usuário',
        usersList: 'Listar usuários',
        userInfo: 'Informação do usuário',
        generateStrongPassword: 'Gerar senha segura',
        deviceWiped: 'Dispositivo Limpo!',
        devices: 'Dispositivos',
        aliases: 'Codinomes',
        remoteWipe: 'Limpar Dispositivo Remotamente',
        remoteWiped: 'limpo remotamente',
        noDevicesAvailable: 'Nenhum dispositivo disponível',
        ecs: 'Usuário do Sistema de Comunicação Corporativa (ECS)',
        emailOrIdentifier: 'E-mail ou identificador de usuário',
        plan: 'Plano',
        noSubscription: 'Sem assinatura',
        planPersonal: 'Personal',
        planPro: 'Pro',
        planGroup: 'Group',
        planFree: 'Free',
        subActive: 'Ativa',
        subCanceled: 'Cancelada',
        subGrace: 'Período de carência',
        subOnHold: 'Suspensa',
        subPaused: 'Pausada',
        subExpired: 'Expirada',
        subRevoked: 'Revogada',
        subPending: 'Pendente',
        subUnknown: 'Desconhecida',
    },
    es: {
        appVersion: 'Versión de la aplicación',
        os: 'Sistema Operativo',
        osVersion: 'Versión del SO',
        searchBy: 'Buscar por un nombre o identificador',
        users: 'Usuarios',
        reInvited: 'reinvitado',
        resendInvite: 'Reenviar invitación',
        thirdPartyNiapDevice: 'Usuario SIP de terceros',
        cellcryptApp: 'Dispositivo Cellcrypt',
        terminateAcctHeader: '¿Está seguro de que desea cancelar su cuenta?',
        terminateAcctWarning: 'Esta acción no se puede deshacer. Será desconectado automáticamente.',
        usersHeader: 'Los siguientes usuarios serán ',
        userCreateTeamError: 'Debe elegir un equipo con licencias disponibles',
        manageUsers: 'Gestionar usuarios',
        userProfile: 'Perfil del usuario',
        usersCreate: 'Crear usuarios',
        usersCreated: 'Usuario creado en',
        userCreate: 'Crear usuario',
        usersList: 'Lista de usuarios',
        userInfo: 'Información del usuario',
        generateStrongPassword: 'Generar contraseña segura',
        deviceWiped: '¡Dispositivo borrado!',
        aliases: 'Alias',
        devices: 'Dispositivos',
        remoteWipe: 'Borrado remoto del dispositivo',
        remoteWiped: 'borrado remotamente',
        noDevicesAvailable: 'No hay dispositivos disponibles',
        ecs: 'Usuario del Sistema de Comunicación Empresarial',
        emailOrIdentifier: 'E-mail o identificador de usuario',
        plan: 'Plan',
        noSubscription: 'Sin suscripción',
        planPersonal: 'Personal',
        planPro: 'Pro',
        planGroup: 'Group',
        planFree: 'Free',
        subActive: 'Activa',
        subCanceled: 'Cancelada',
        subGrace: 'Período de gracia',
        subOnHold: 'En espera',
        subPaused: 'Pausada',
        subExpired: 'Expirada',
        subRevoked: 'Revocada',
        subPending: 'Pendiente',
        subUnknown: 'Desconocida',
    },
    fr: {
        appVersion: 'Version de l\'application',
        os: 'Système d\'exploitation',
        osVersion: 'Version du SE',
        searchBy: 'Rechercher par nom ou nom d\'utilisateur',
        reInvited: 're-invité',
        resendInvite: 'Renvoyer l\'invitation',
        thirdPartyNiapDevice: 'Utilisateur SIP tiers',
        cellcryptApp: 'Appareil Cellcrypt',
        terminateAcctHeader: 'Êtes-vous sûr de vouloir résilier votre compte ?',
        terminateAcctWarning: 'Cette action ne peut pas être annulée. Vous serez automatiquement déconnecté.',
        usersHeader: 'Les utilisateurs suivants seront ',
        userCreateTeamError: 'Vous devez choisir une entreprise avec des licences disponibles',
        users: 'Utilisateurs',
        manageUsers: 'Gérer les utilisateurs',
        userProfile: 'Profil utilisateur',
        usersCreate: 'Créer des utilisateurs',
        usersCreated: 'Utilisateur créé le',
        userCreate: 'Créer un utilisateur',
        usersList: 'Liste des utilisateurs',
        userInfo: 'Informations utilisateur',
        generateStrongPassword: 'Générer un mot de passe fort',
        deviceWiped: 'Appareil effacé !',
        aliases: 'Alias',
        devices: 'Appareils',
        remoteWipe: 'Effacer l\'appareil à distance',
        remoteWiped: 'effacé à distance',
        noDevicesAvailable: 'Aucun appareil disponible',
        ecs: 'Utilisateur du système de communication d\'entreprise',
        emailOrIdentifier: 'E-mail ou identifiant utilisateur',
        plan: 'Forfait',
        noSubscription: 'Aucun abonnement',
        planPersonal: 'Personal',
        planPro: 'Pro',
        planGroup: 'Group',
        planFree: 'Free',
        subActive: 'Actif',
        subCanceled: 'Annulé',
        subGrace: 'Période de grâce',
        subOnHold: 'En attente',
        subPaused: 'En pause',
        subExpired: 'Expiré',
        subRevoked: 'Révoqué',
        subPending: 'En attente',
        subUnknown: 'Inconnu',
    }
}

const dashboard = {
    en: {
        deploymentMessage: "To begin deploying {platform} to yourself and your team, {action}",
        youMustPurchase: 'you need to purchase a License Pack',
        youMustActivate: 'you need to activate your Licenses',
        inviteMessage: "To begin using {platform}, you will need to send an invite to each member of your team (including you)",
        getStarted: 'Get Started',
        extendExistingLicensePacks: 'Extend existing license packs',
        dashLicenseInfo: 'License information',
        userStatus: 'User status',
        totalUsers: 'Total # of users',
        totalActive: 'Active',
        totalPending: 'Pending',
        totalBlocked: 'Blocked',
        deviceTypes: 'Device types',
        appVersions: 'App versions',
        totalActivePacks: 'License packs',
        totalNumLicenses: 'Total # of licenses',
        nextToExpire: 'Next expiration date',
        totalInvitedUsers: 'User invites',
        totalUsedLicenses: 'Used licenses',
        totalAvailableLicenses: 'Available licenses',
    },
    pt: {
        deploymentMessage: "Para começar a implantar {platform} para você e sua equipe, {action}",
        inviteMessage: "Para começar a usar {platform}, você deve enviar um convite para cada membro da sua equipe (incluindo você)",
        youMustPurchase: "é necessário comprar um Pacote de Licenças",
        youMustActivate: "é necessário ativar suas Licenças",
        getStarted: 'Comece agora',
        extendExistingLicensePacks: 'Estender pacotes de licenças existentes',
        dashLicenseInfo: 'Informações sobre licenças',
        userStatus: 'Status dos usuários',
        totalUsers: '# total de usuários',
        totalActive: 'Ativo',
        totalPending: 'Pendente',
        totalBlocked: 'Bloqueado',
        deviceTypes: 'Tipos de dispositivo',
        appVersions: 'Versões de aplicativo',
        totalActivePacks: 'Pacotes de licença',
        totalNumLicenses: '# total de licenças',
        nextToExpire: 'Próxima data de expiração',
        totalInvitedUsers: 'Usuários convidados',
        totalUsedLicenses: 'Licenças usadas',
        totalAvailableLicenses: 'Licenças disponíveis',
    },
    es: {
        inviteMessage: "Para comenzar a usar {platform}, necesitarás enviar una invitación a cada miembro de tu equipo (incluyéndote a ti)",
        deploymentMessage: "Para comenzar a desplegar {platform} para ti e tu equipo, {action}",
        youMustPurchase: "necesitas comprar un Paquete de Licencias",
        youMustActivate: "necesitas activar tus Licencias",
        getStarted: 'Empezar',
        extendExistingLicensePacks: 'Ampliar paquetes de licencias existentes',
        dashLicenseInfo: 'Información de licencias',
        userStatus: 'Estado del usuario',
        totalUsers: 'Número total de usuarios',
        totalActive: 'Activo',
        totalPending: 'Pendiente',
        totalBlocked: 'Bloqueado',
        deviceTypes: 'Tipos de dispositivos',
        appVersions: 'Versiones de la aplicación',
        totalActivePacks: 'Paquetes de licencias',
        totalNumLicenses: '# total de licencias',
        nextToExpire: 'Próxima fecha de expiración',
        totalInvitedUsers: 'Usuarios invitados',
        totalUsedLicenses: 'Licencias usadas',
        totalAvailableLicenses: 'Licencias disponibles',
    },
    fr: {
        deploymentMessage: "Pour commencer à déployer {platform} pour vous et votre équipe, {action}",
        youMustPurchase: 'vous devez acheter un pack de licences',
        youMustActivate: 'vous devez activer vos licences',
        inviteMessage: "Pour commencer à utiliser {platform}, vous devrez envoyer une invitation à chaque membre de votre équipe (y compris vous)",
        getStarted: 'Commencer',
        extendExistingLicensePacks: 'Étendre les packs de licences existants',
        dashLicenseInfo: 'Informations sur les licences',
        userStatus: 'Statut des utilisateurs',
        totalUsers: 'Nombre total d\'utilisateurs',
        totalActive: 'Actif',
        totalPending: 'En attente',
        totalBlocked: 'Bloqué',
        deviceTypes: 'Types d\'appareils',
        appVersions: 'Versions de l\'application',
        totalActivePacks: 'Packs de licences',
        totalNumLicenses: 'Nombre total de licences',
        nextToExpire: 'Prochaine date d\'expiration',
        totalInvitedUsers: 'Invitations d\'utilisateurs',
        totalUsedLicenses: 'Licences utilisées',
        totalAvailableLicenses: 'Licences disponibles',
    }
}

const general = {
    en: {
        recaptchaError: 'Recaptcha Error',
        never: 'never',
        optional: 'Optional',
        domain: 'Domain',
        profileUpdateSuccessful: 'Profile Updated Successfully',
        profileUpdateFailed: 'Unable to update profile',
        loading: 'Loading...',
        password: 'Password',
        typeCurrentPword: 'Type current password',
        newPassword: 'New password',
        repeatNewPassword: 'Repeat new password',
        noDataAvailable: 'No Data Available',
        failedAttempts: 'Failed attempts',
        successfulAttempts: 'Successful attempts',
        theFollowingAdminsWill: 'The following admins will be',
        theFollowingUsersWill: 'The following users will be',
        theFollowingTeamsWill: 'The following companies will be',
        theFollowingDevicesWill: 'The following devices will be',
        theFollowingAssociationsWill: 'The following association will be',
        usernameNotEmail: 'This account is not registered using a valid e-mail address!',
        noUserSelected: 'No user selected',
        lessThanMinuteAgo: 'Less than a minute ago',
        hoursAnd: ' hours and ',
        hourAnd: ' hour and ',
        minutesAnd: ' minutes and ',
        minuteAnd: ' minute and ',
        daysAgo: ' days ago',
        dayAgo: ' day ago',
        minutesAgo: ' minutes ago',
        minuteAgo: ' minute ago',
        osVersion: 'OS Version',
        appVersion: 'App Version',
        osID: 'OS',
        comingSoon: 'coming soon',
        support: 'Support',
        today: 'Today',
        thisWeek: 'This week',
        thisMonth: 'This month',
        longTimeAgo: 'A long time ago'
    },
    pt: {
        recaptchaError: 'Recaptcha Error',
        never: 'nunca',
        optional: 'Opcional',
        domain: 'Domínio',
        profileUpdateSuccessful: 'Atualização de perfil bem sucedida',
        profileUpdateFailed: 'Não foi possível atualizar o perfil',
        loading: 'Carregando...',
        password: 'Senha',
        typeCurrentPword: 'Digite senha atual',
        newPassword: 'Nova senha',
        repeatNewPassword: 'Repita nova senha',
        noDataAvailable: 'Dados inexistentes',
        failedAttempts: 'Tentativas mal-sucedidas',
        successfulAttempts: 'Tentativas bem sucedidas',
        theFollowingAdminsWill: 'Os seguintes administradores serão',
        theFollowingUsersWill: 'Os seguintes usuários serão',
        theFollowingTeamsWill: 'Os seguintes times serão',
        theFollowingDevicesWill: 'Os seguintes dispositivos serão',
        theFollowingAssociationsWill: 'A seguinte associação será',
        usernameNotEmail: 'Esta conta não foi criada usando um endereço de e-mail válido!',
        noUserSelected: 'Nenhum usuário selecionado',
        osID: 'SO',
        osVersion: 'Versão SO',
        appVersion: 'Versão App',
        minutesAgo: ' minutos atrás',
        minuteAgo: ' minuto atrás',
        daysAgo: ' dias atrás',
        dayAgo: ' dia atrás',
        hoursAnd: ' horas e ',
        hourAnd: ' hora e ',
        minutesAnd: ' minutos e ',
        minuteAnd: ' minuto e ',
        lessThanMinuteAgo: 'A menos de um minuto atrás',
        comingSoon: 'disponível em breve',
        support: 'Suporte',
        today: 'Hoje',
        thisWeek: 'Esta semana',
        thisMonth: 'Este mês',
        longTimeAgo: 'Há muito tempo'
    },
    es: {
        recaptchaError: 'Recaptcha Error',
        never: 'nunca',
        optional: 'Opcional',
        domain: 'Dominio',
        profileUpdateSuccessful: 'Perfil actualizado con éxito',
        profileUpdateFailed: 'No se pudo actualizar el perfil',
        loading: 'Cargando...',
        password: 'Contraseña',
        typeCurrentPword: 'Escriba la contraseña actual',
        newPassword: 'Nueva contraseña',
        repeatNewPassword: 'Repetir nueva contraseña',
        noDataAvailable: 'No hay datos disponibles',
        failedAttempts: 'Intentos fallidos',
        successfulAttempts: 'Intentos exitosos',
        theFollowingAdminsWill: 'Los siguientes administradores serán',
        theFollowingUsersWill: 'Los siguientes usuarios serán',
        theFollowingTeamsWill: 'Los siguientes equipos serán',
        theFollowingDevicesWill: 'Los siguientes dispositivos serán',
        theFollowingAssociationsWill: 'La siguiente asociación será',
        usernameNotEmail: '¡Esta cuenta no está registrada con una dirección de correo electrónico válida!',
        noUserSelected: 'No se ha seleccionado ningún usuario',
        osID: 'SO',
        osVersion: 'Versión SO',
        appVersion: 'Versión de la aplicación',
        minutesAgo: ' minutos atrás',
        minuteAgo: ' minuto atrás',
        daysAgo: ' días atrás',
        dayAgo: ' día atrás',
        hoursAnd: ' horas y ',
        hourAnd: ' hora y ',
        minutesAnd: ' minutos y ',
        minuteAnd: ' minuto y ',
        lessThanMinuteAgo: 'Hace menos de un minuto',
        comingSoon: 'próximamente',
        support: 'Soporte',
        today: 'Hoy',
        thisWeek: 'Esta semana',
        thisMonth: 'Este mes',
        longTimeAgo: 'Hace mucho tiempo'
    },
    fr: {
        recaptchaError: 'Erreur Recaptcha',
        never: 'jamais',
        optional: 'Optionnel',
        domain: 'Domaine',
        profileUpdateSuccessful: 'Profil mis à jour avec succès',
        profileUpdateFailed: 'Impossible de mettre à jour le profil',
        loading: 'Chargement...',
        password: 'Mot de passe',
        typeCurrentPword: 'Saisissez le mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        repeatNewPassword: 'Répétez le nouveau mot de passe',
        noDataAvailable: 'Aucune donnée disponible',
        failedAttempts: 'Tentatives échouées',
        successfulAttempts: 'Tentatives réussies',
        theFollowingAdminsWill: 'Les administrateurs suivants seront',
        theFollowingUsersWill: 'Les utilisateurs suivants seront',
        theFollowingTeamsWill: 'Les entreprises suivantes seront',
        theFollowingDevicesWill: 'Les appareils suivants seront',
        theFollowingAssociationsWill: 'L\'association suivante sera',
        usernameNotEmail: 'Ce compte n\'est pas enregistré avec une adresse e-mail valide !',
        noUserSelected: 'Aucun utilisateur sélectionné',
        lessThanMinuteAgo: 'Il y a moins d\'une minute',
        hoursAnd: ' heures et ',
        hourAnd: ' heure et ',
        minutesAnd: ' minutes et ',
        minuteAnd: ' minute et ',
        daysAgo: ' jours',
        dayAgo: ' jour',
        minutesAgo: ' minutes',
        minuteAgo: ' minute',
        osVersion: 'Version OS',
        appVersion: 'Version de l\'application',
        osID: 'OS',
        comingSoon: 'bientôt disponible',
        support: 'Support',
        today: 'Aujourd\'hui',
        thisWeek: 'Cette semaine',
        thisMonth: 'Ce mois',
        longTimeAgo: 'Il y a longtemps'
    }
}

const settings = {
    en: {
        warningBannerEn: "EMP Warning Banner (EN)",
        warningBannerPt: "EMP Warning Banner (PT)",
        warningBannerEs: "EMP Warning Banner (ES)",
        warningBannerFr: "EMP Warning Banner (FR)",
        mutualAuth: 'Mutual Authentication',
        tlsDomainSettings: 'TLS/Domain Settings',
        api_url: 'API Prefix',
        aux_url: 'AUX Prefix',
        sip_url: 'SIP Prefix',
        vault_url: 'VAULT Prefix',
        emp_url: 'EMP Prefix',
        my_url: 'MY Prefix',
        generalSettings: 'General Settings',
        messageSettings: 'Message Settings',
        callingSettings: 'Call Settings',
        attachmentSettings: 'Attachment Settings',
        msgAttCallSettings: 'Message, Attachment and Call Settings',
        securitySettings: 'Security Settings',
        crashReporting: 'Crash reports',
        mdsEnabled: 'Multiple Device Support',
        niapMode: 'NIAP compliant mode',
        emailingEnabled: 'Use e-mail notifications',
        registrationEnabled: 'Allow outside users to register new companies',
        freeUsage: 'Free usage for self-onboarded users',
        adminEMPTokenExpiration: 'Session expiration (in hours) for EMP',
        adminRegTokenExpiration: 'Token expiration (in minutes) for admin registrations',
        adminPwordResetTokenExpiration: 'Token expiration (in minutes) for admin password resets',
        userRegTokenExpiration: 'Token expiration (in minutes) for user registrations',
        userPwordResetTokenExpiration: 'Token expiration (in minutes) for user password resets',
        userInviteExpiration: 'User Invite Expiration (in days)',
        userInviteLength: 'Length of User Invite Tokens (in characters)',
        otpLength: 'One Time Password length (in characters)',
        otpTTL: 'One Time Password expiration (in minutes)',
        messageTTL: 'TTL (in seconds) for messages',
        attachmentTTL: 'TTL (in minutes) for attachments',
        rateLimitAttachments: 'Rate Limit for attachments',
        rateLimitMessages: 'Rate Limit for messages',
        rateLimitCalling: 'Rate Limit for calls',
        callTimeoutDefault: 'Default call timeout (in seconds)',
        callTimeoutMax: 'Maximum call timeout (in seconds)',
        callTimeoutMin: 'Minimum call timeout (in seconds)',
        sipReregisterInterval: 'SIP re-register interval (in seconds)',
        turnPassword: 'TURN/STUN password',
        turnUrl: 'TURN/STUN URL',
        turnUsername: 'TURN/STUN username',
        pinLock: 'Pin-lock',
        adminMaxNumberAdminSigninAttempts: 'Maximum number of failed admin sign-in attempts',
        userMaxNumberUserSigninAttempts: 'Maximum number of failed user sign-in attempts',
        repeatedAdminPwordHistory: 'Administrator password history',
        repeatedUserPwordHistory: 'User password history',
    },
    pt: {
        warningBannerEn: "Banner de advertência do EMP (EN)",
        warningBannerEs: "Banner de advertência do EMP (ES)",
        warningBannerPt: "Banner de advertência do EMP (PT)",
        warningBannerFr: "Banner de advertência do EMP (FR)",
        mutualAuth: 'Autenticação Mútua',
        tlsDomainSettings: 'Configurações TLS/Domínio',
        api_url: 'Prefixo API',
        aux_url: 'Prefixo AUX',
        sip_url: 'Prefixo SIP',
        vault_url: 'Prefixo VAULT',
        emp_url: 'Prefixo EMP',
        my_url: 'Prefixo MY',
        generalSettings: 'Configurações Gerais',
        messageSettings: 'Configuração de Mensagens',
        callingSettings: 'Configuração de Chamadas',
        attachmentSettings: 'Configuração de Anexos',
        msgAttCallSettings: 'Configuração de Mensagens, Anexos e Chamadas',
        securitySettings: 'Configurações de Segurança',
        crashReporting: 'Relatório de problemas',
        mdsEnabled: 'Suporte a múltiplos dispositivos',
        niapMode: 'NIAP compliant mode',
        emailingEnabled: 'Usar notificações via e-mail',
        registrationEnabled: 'Permitir usuários externos criarem times',
        freeUsage: 'Uso gratuito para usuários auto-cadastrados',
        adminEMPTokenExpiration: 'Expiração da sessão (em horas) para EMP',
        adminRegTokenExpiration: 'Expiração do código para registro de administradores (em minutos) ',
        adminPwordResetTokenExpiration: 'Expiração do código para redefinição de senhas de administradores (em minutos) ',
        userRegTokenExpiration: 'Expiração (em minutos) do token para registro de usuários',
        userPwordResetTokenExpiration: 'Expiração (em minutos) do token para redefinição de senha de usuários',
        userInviteExpiration: 'Expiração de convite para usuário (em dias)',
        userInviteLength: 'Tamanho do código de convite de usuário (em caracteres)',
        otpLength: 'Tamanho da senha de uso único (em caracteres)',
        otpTTL: 'Expiração da senha de uso único (em caracteres)',
        messageTTL: 'Tempo de vida (em segundos) para mensagens',
        attachmentTTL: 'TTL (em minutos) para anexos',
        rateLimitAttachments: 'Rate Limit for attachments',
        rateLimitCalling: 'Limite de acesso para ligações',
        rateLimitMessages: 'Limite de acesso para mensagens',
        callTimeoutDefault: 'Timeout padrão para ligações (em segundos)',
        callTimeoutMax: 'Timeout para ligações máximo (em segundos)',
        callTimeoutMin: 'Timeout para ligações mínimo (em segundos)',
        sipReregisterInterval: 'SIP re-register interval (em segundos)',
        turnPassword: 'TURN/STUN password',
        turnUrl: 'TURN/STUN URL',
        turnUsername: 'TURN/STUN username',
        pinLock: 'Pin-lock',
        adminMaxNumberAdminSigninAttempts: 'Número máximo de tentativas de acesso de administradores',
        userMaxNumberUserSigninAttempts: 'Número máximo de tentativas de acesso de usuário',
        repeatedAdminPwordHistory: 'Histórico de senhas repetidas de administradores',
        repeatedUserPwordHistory: 'Histórico de senhas repetidas de usuários',
    },
    es: {
        warningBannerEn: "Banner de advertência do EMP (EN)",
        warningBannerEs: "Banner de advertência do EMP (ES)",
        warningBannerPt: "Banner de advertência do EMP (PT)",
        warningBannerFr: "Banner de advertência do EMP (FR)",
        mutualAuth: 'Autenticación mutua',
        tlsDomainSettings: 'Configuraciones TLS/Dominio',
        api_url: 'Prefijo API',
        aux_url: 'Prefijo AUX',
        sip_url: 'Prefijo SIP',
        vault_url: 'Prefijo VAULT',
        emp_url: 'Prefijo EMP',
        my_url: 'Prefijo MY',
        generalSettings: 'Configuraciones generales',
        messageSettings: 'Configuración de mensajes',
        callingSettings: 'Configuración de llamadas',
        attachmentSettings: 'Configuración de archivos adjuntos',
        msgAttCallSettings: 'Configuración de mensajes, archivos adjuntos y llamadas',
        securitySettings: 'Configuraciones de seguridad',
        crashReporting: 'Informes de fallos',
        mdsEnabled: 'Soporte para múltiples dispositivos',
        niapMode: 'Modo compatible con NIAP',
        emailingEnabled: 'Usar notificaciones por correo electrónico',
        registrationEnabled: 'Allow outside users to register new teams',
        freeUsage: 'Uso gratuito para usuarios auto-registrados',
        adminEMPTokenExpiration: 'Expiración de sesión (en horas) para EMP',
        adminRegTokenExpiration: 'Expiración del token (en minutos) para registros de administradores',
        adminPwordResetTokenExpiration: 'Expiración del token (en minutos) para restablecimientos de contraseña de administradores',
        userRegTokenExpiration: 'Expiración del token (en minutos) para registros de usuarios',
        userPwordResetTokenExpiration: 'Expiración del token (en minutos) para restablecimientos de contraseña de usuarios',
        userInviteExpiration: 'Expiración de la invitación de usuario (en dias)',
        userInviteLength: 'Longitud de la contraseña de invitación de usuario (en caracteres)',
        otpLength: 'Longitud de la contraseña de un solo uso (en caracteres)',
        otpTTL: 'Expiración de la contraseña de un solo uso (en minutos)',
        messageTTL: 'TTL (en segundos) para mensajes',
        attachmentTTL: 'TTL (en minutos) para archivos adjuntos',
        rateLimitAttachments: 'Límite de tasa para archivos adjuntos',
        rateLimitMessages: 'Límite de tasa para mensajes',
        rateLimitCalling: 'Límite de tasa para llamadas',
        callTimeoutDefault: 'Tiempo de espera predeterminado para llamadas (en segundos)',
        callTimeoutMax: 'Tiempo de espera máximo para llamadas (en segundos)',
        callTimeoutMin: 'Tiempo de espera mínimo para llamadas (en segundos)',
        sipReregisterInterval: 'Intervalo de re-registro SIP (en segundos)',
        turnPassword: 'Contraseña TURN/STUN',
        turnUrl: 'URL TURN/STUN',
        turnUsername: 'Nombre de usuario TURN/STUN',
        pinLock: 'Bloqueo por pin',
        adminMaxNumberAdminSigninAttempts: 'Número máximo de intentos de inicio de sesión de administrador',
        userMaxNumberUserSigninAttempts: 'Número máximo de intentos de inicio de sesión de usuario',
        repeatedAdminPwordHistory: 'Historial de contraseñas repetidas de administrador',
        repeatedUserPwordHistory: 'Historial de contraseñas repetidas de usuario',
    },
    fr: {
        warningBannerEn: 'Bannière d\'avertissement EMP (EN)',
        warningBannerPt: 'Bannière d\'avertissement EMP (PT)',
        warningBannerEs: 'Bannière d\'avertissement EMP (ES)',
        mutualAuth: 'Authentification mutuelle',
        tlsDomainSettings: 'Paramètres TLS/Domaine',
        api_url: 'Préfixe API',
        aux_url: 'Préfixe AUX',
        sip_url: 'Préfixe SIP',
        vault_url: 'Préfixe VAULT',
        emp_url: 'Préfixe EMP',
        my_url: 'Préfixe MY',
        generalSettings: 'Paramètres généraux',
        messageSettings: 'Paramètres des messages',
        callingSettings: 'Paramètres d\'appel',
        attachmentSettings: 'Paramètres des pièces jointes',
        msgAttCallSettings: 'Paramètres des messages, pièces jointes et appels',
        securitySettings: 'Paramètres de sécurité',
        crashReporting: 'Rapports de plantage',
        mdsEnabled: 'Support multi-appareils',
        niapMode: 'Mode conforme NIAP',
        emailingEnabled: 'Utiliser les notifications par e-mail',
        registrationEnabled: 'Permettre aux utilisateurs externes d\'enregistrer de nouvelles entreprises',
        freeUsage: 'Utilisation gratuite pour les utilisateurs auto-inscrits',
        adminEMPTokenExpiration: 'Expiration de session (en heures) pour EMP',
        adminRegTokenExpiration: 'Expiration du jeton (en minutes) pour les enregistrements d\'administrateur',
        adminPwordResetTokenExpiration: 'Expiration du jeton (en minutes) pour les réinitialisations de mot de passe d\'administrateur',
        userRegTokenExpiration: 'Expiration du jeton (en minutes) pour les enregistrements d\'utilisateur',
        userPwordResetTokenExpiration: 'Expiration du jeton (en minutes) pour les réinitialisations de mot de passe d\'utilisateur',
        userInviteExpiration: 'Expiration des invitations utilisateur (en jours)',
        userInviteLength: 'Longueur des jetons d\'invitation utilisateur (en caractères)',
        otpLength: 'Longueur du mot de passe à usage unique (en caractères)',
        otpTTL: 'Expiration du mot de passe à usage unique (en minutes)',
        messageTTL: 'TTL (en secondes) pour les messages',
        attachmentTTL: 'TTL (en minutes) pour les pièces jointes',
        rateLimitAttachments: 'Limite de débit pour les pièces jointes',
        rateLimitMessages: 'Limite de débit pour les messages',
        rateLimitCalling: 'Limite de débit pour les appels',
        callTimeoutDefault: 'Délai d\'attente d\'appel par défaut (en secondes)',
        callTimeoutMax: 'Délai d\'attente d\'appel maximum (en secondes)',
        callTimeoutMin: 'Délai d\'attente d\'appel minimum (en secondes)',
        sipReregisterInterval: 'Intervalle de re-enregistrement SIP (en secondes)',
        turnPassword: 'Mot de passe TURN/STUN',
        turnUrl: 'URL TURN/STUN',
        turnUsername: 'Nom d\'utilisateur TURN/STUN',
        pinLock: 'Verrouillage par code PIN',
        adminMaxNumberAdminSigninAttempts: 'Nombre maximum de tentatives de connexion échouées pour les administrateurs',
        userMaxNumberUserSigninAttempts: 'Nombre maximum de tentatives de connexion échouées pour les utilisateurs',
        repeatedAdminPwordHistory: 'Historique des mots de passe administrateur',
        repeatedUserPwordHistory: 'Historique des mots de passe utilisateur',
    }
}

const publicKeys = {
    en: {
        verifyAccount: 'Verify your e-mail address',
        registerNow: 'Register now!',
        register: 'Register',
        confirmRegistration: 'Confirm registration',
        toCreateAccount: 'To create an account, please choose a name for your user and company:',
        readTermsOfService: 'I have read and agreed to the',
        termsOfService: 'terms of service',
        alreadyHaveAccount: 'Already have an account?',
        login: 'Login',
        forgotPassword: 'Forgot Password?',
        notYetHaveAccount: 'Do you not yet have an account?',
        backToSignIn: 'Go Back To Sign-In Page',
        accountVerificationRequest: 'Please click on the button below to confirm your e-mail address and activate your account!',
        accountVerificationSuccessful: 'Account verification successful! \nYou may now proceed to the sign-in page and start using the platform!',
        email: 'Username (must be a valid e-mail address)',
        passwordResetSuccessful: `Password reset successfully sent. The sent password reset
        link will expire in an hour. Please check your email for further instructions.`,
        resetYourPassword: 'Reset your Password',
        defineYourPassword: 'Reset your Password',
    },
    pt: {
        verifyAccount: 'Verifique sua conta',
        registerNow: 'Registre sua conta agora!',
        register: 'Registrar',
        confirmRegistration: 'Confirme seu registro',
        toCreateAccount: 'Para criar uma conta, escolha um nome para seu usuário e time:',
        readTermsOfService: 'Eu li e concordo com os',
        termsOfService: 'termos de serviço',
        alreadyHaveAccount: 'Já possui uma conta?',
        login: 'Acessar',
        forgotPassword: 'Esqueceu sua senha?',
        notYetHaveAccount: 'Você ainda não tem uma conta?',
        backToSignIn: 'Voltar a página de acesso',
        accountVerificationRequest: 'Por favor clique no botão abaixo para confirmar seu e-mail e ativar sua conta!',
        accountVerificationSuccessful: 'Verificação de conta bem sucedida! Você agora já pode ir a página de acesso e começar a usar a plataforma!',
        email: 'Nome do usuário (deve ser um e-mail válido)',
        passwordResetSuccessful: `E-mail para redefinição da senha enviado com sucesso. Este e-mail é válido 
        por uma hora. Por favor leia seu e-mail para mais instruções.`,
        resetYourPassword: 'Redefina sua senha',
        defineYourPassword: 'Defina sua senha',
    },
    es: {
        verifyAccount: 'Verifica tu dirección de correo electrónico',
        registerNow: '¡Regístrate ahora!',
        register: 'Registrar',
        confirmRegistration: 'Confirmar registro',
        toCreateAccount: 'Para crear una cuenta, elija un nombre para su usuario y equipo:',
        readTermsOfService: 'He leído y acepto los',
        termsOfService: 'términos de servicio',
        alreadyHaveAccount: '¿Ya tienes una cuenta?',
        login: 'Iniciar sesión',
        forgotPassword: '¿Olvidaste tu contraseña?',
        notYetHaveAccount: '¿Aún no tienes una cuenta?',
        backToSignIn: 'Volver a la página de inicio de sesión',
        accountVerificationRequest: '¡Haga clic en el botón de abajo para confirmar su dirección de correo electrónico y activar su cuenta!',
        accountVerificationSuccessful: '¡Verificación de cuenta exitosa! Ahora puede ir a la página de inicio de sesión y comenzar a usar la plataforma.',
        email: 'Nombre de usuario (debe ser una dirección de correo electrónico válida)',
        passwordResetSuccessful: `Restablecimiento de contraseña enviado con éxito. El enlace de restablecimiento de contraseña enviado expirará en una hora. Por favor, revise su correo electrónico para más instrucciones.`,
        resetYourPassword: 'Restablece tu contraseña',
        defineYourPassword: 'Establece tu contraseña',
    },
    fr: {
        verifyAccount: 'Vérifiez votre adresse e-mail',
        registerNow: 'Inscrivez-vous maintenant !',
        register: 'S\'inscrire',
        confirmRegistration: 'Confirmer l\'inscription',
        toCreateAccount: 'Pour créer un compte, veuillez choisir un nom pour votre utilisateur et votre entreprise :',
        readTermsOfService: 'J\'ai lu et accepté les',
        termsOfService: 'conditions de service',
        alreadyHaveAccount: 'Vous avez déjà un compte ?',
        login: 'Connexion',
        forgotPassword: 'Mot de passe oublié ?',
        notYetHaveAccount: 'Vous n\'avez pas encore de compte ?',
        backToSignIn: 'Retourner à la page de connexion',
        accountVerificationRequest: 'Veuillez cliquer sur le bouton ci-dessous pour confirmer votre adresse e-mail et activer votre compte !',
        accountVerificationSuccessful: 'Vérification du compte réussie ! Vous pouvez maintenant vous rendre sur la page de connexion et commencer à utiliser la plateforme !',
        email: 'Nom d\'utilisateur (doit être une adresse e-mail valide)',
        passwordResetSuccessful: 'Réinitialisation du mot de passe envoyée avec succès. Le lien de réinitialisation du mot de passe envoyé expirera dans une heure. Veuillez vérifier votre e-mail pour plus d\'instructions.',
        resetYourPassword: 'Réinitialisez votre mot de passe',
        defineYourPassword: 'Définissez votre mot de passe',
    }
}

const actionsStatus = {
    en: {
        toggleMenu: 'Toggle side menu',
        confirm: 'Confirm',
        or: 'or',
        paginationRowsPerPage: 'Items per page',
        paginationOf: 'of',
        na: 'Not Available',
        save: 'Save',
        upload: 'Upload',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        edit: 'Edit',
        add: 'Add',
        signOut: 'Sign out',
        active: 'Active',
        verified: 'Verified',
        accepted: 'Accepted',
        pending: 'Pending',
        actions: 'Actions',
        error: 'Error',
        empty: 'x',
        search: 'Search',
        delete: 'Delete',
        deleteDevice: 'Delete Device',
        deleted: 'deleted',
        dismiss: 'Dismiss',
        bulkDelete: 'Bulk Delete',
        bulkMove: 'Bulk Move',
        block: 'Block',
        blocked: 'blocked',
        moved: 'moved',
        blocked2: 'Blocked',
        activate: 'Activate',
        forceVerify: 'Force verify',
        activated: 'activated',
        terminate: 'Terminate',
        viewEdit: 'View/Edit',
        manage: 'Manage',
        invite: 'Invite',
        purchase: 'Purchase',
        clear: 'Clear',
        expired: 'expired',
        extended: 'extended',
        backUserManagement: '< Back to User Management',
        backAdminManagement: '< Back to Admin Management',
        backTeamManagement: '< Back to Company Management',
        backLicenseManagement: '< Back to License Management',
        create: 'Create',
    },
    pt: {
        toggleMenu: 'Ativar menu lateral',
        confirm: 'Confirmar',
        or: 'ou',
        paginationRowsPerPage: 'Itens por página',
        paginationOf: 'de',
        na: 'Indisponível',
        save: 'Salvar',
        upload: 'Carregar',
        close: 'Fechar',
        back: 'Voltar',
        next: 'Próxima',
        edit: 'Editar',
        add: 'Adicionar',
        signOut: 'Sair',
        active: 'Ativo',
        verified: 'Verificado',
        accepted: 'Aceito',
        pending: 'Pendente',
        actions: 'Ações',
        error: 'Erro',
        empty: 'x',
        search: 'Busca',
        delete: 'Remover',
        deleteDevice: 'Remover Dispositivo',
        deleted: 'removidos',
        dismiss: 'Fechar',
        bulkDelete: 'Remover em Grupo',
        bulkMove: 'Mover em Grupo',
        block: 'Bloquear',
        blocked: 'bloqueados',
        moved: 'movidos',
        blocked2: 'Bloqueado',
        activate: 'Ativar',
        forceVerify: 'Forçar verificação',
        activated: 'ativados',
        terminate: 'Encerrar Conta',
        viewEdit: 'Visualizar/Editar',
        manage: 'Gerenciar',
        invite: 'Convidar',
        purchase: 'Comprar',
        clear: 'Limpar',
        expired: 'expiradas',
        extended: 'extendida',
        backUserManagement: '< Voltar ao Painel de usuários',
        backAdminManagement: '< Voltar ao Painel de Administradores',
        backTeamManagement: '< Voltar ao Painel de Times',
        backLicenseManagement: '< Voltar ao Painel de Licenças',
        create: 'Criar',
    },
    es: {
        toggleMenu: 'Activar menú lateral',
        confirm: 'Confirmar',
        or: 'o',
        paginationRowsPerPage: 'Elementos por página',
        paginationOf: 'de',
        na: 'No disponible',
        save: 'Guardar',
        upload: 'Subir',
        close: 'Cerrar',
        back: 'Atrás',
        next: 'Siguiente',
        edit: 'Editar',
        add: 'Añadir',
        signOut: 'Cerrar sesión',
        active: 'Activo',
        verified: 'Verificado',
        accepted: 'Aceptado',
        pending: 'Pendiente',
        actions: 'Acciones',
        error: 'Error',
        empty: 'x',
        search: 'Buscar',
        delete: 'Eliminar',
        deleteDevice: 'Eliminar dispositivo',
        deleted: 'eliminado',
        dismiss: 'Descartar',
        bulkDelete: 'Eliminar en grupo',
        bulkMove: 'Mover en grupo',
        block: 'Bloquear',
        blocked: 'bloqueado',
        moved: 'movidos',
        blocked2: 'Bloqueado',
        activate: 'Activar',
        forceVerify: 'Forzar verificación',
        activated: 'activado',
        terminate: 'Terminar',
        viewEdit: 'Ver/Editar',
        manage: 'Gestionar',
        invite: 'Invitar',
        purchase: 'Comprar',
        clear: 'Limpiar',
        expired: 'expirado',
        extended: 'estendida',
        backUserManagement: '< Volver a la gestión de usuarios',
        backAdminManagement: '< Volver a la gestión de administradores',
        backTeamManagement: '< Volver a la gestión de equipos',
        backLicenseManagement: '< Volver a la gestión de licencias',
        create: 'Crear'
    },
    fr: {
        toggleMenu: 'Basculer le menu latéral',
        confirm: 'Confirmer',
        or: 'ou',
        paginationRowsPerPage: 'Éléments par page',
        paginationOf: 'de',
        na: 'Non disponible',
        save: 'Enregistrer',
        upload: 'Télécharger',
        close: 'Fermer',
        back: 'Retour',
        next: 'Suivant',
        edit: 'Modifier',
        add: 'Ajouter',
        signOut: 'Se déconnecter',
        active: 'Actif',
        verified: 'Vérifié',
        accepted: 'Accepté',
        pending: 'En attente',
        actions: 'Actions',
        error: 'Erreur',
        empty: 'x',
        search: 'Rechercher',
        delete: 'Supprimer',
        deleteDevice: 'Supprimer l\'appareil',
        deleted: 'supprimé',
        dismiss: 'Fermer',
        bulkDelete: 'Suppression en masse',
        bulkMove: 'Déplacement en masse',
        block: 'Bloquer',
        blocked: 'bloqué',
        moved: 'déplacé',
        blocked2: 'Bloqué',
        activate: 'Activer',
        forceVerify: 'Forcer la vérification',
        activated: 'activé',
        terminate: 'Résilier',
        viewEdit: 'Voir/Modifier',
        manage: 'Gérer',
        invite: 'Inviter',
        purchase: 'Acheter',
        clear: 'Effacer',
        expired: 'expiré',
        extended: 'étendu',
        backUserManagement: '< Retour à la gestion des utilisateurs',
        backAdminManagement: '< Retour à la gestion des administrateurs',
        backTeamManagement: '< Retour à la gestion des entreprises',
        backLicenseManagement: '< Retour à la gestion des licences',
        create: 'Créer',
    }
}

const headers = {
    en: {
        quickAction: 'Quick Action',
        listTeamLicenses: 'List of licenses associated with this company',
        listTeamAdmins: 'List of admins with access to this company',
        settings: 'Settings',
        general: 'General',
        dashboard: 'Dashboard',
        accessLogs: 'Access Logs',
        greeting: 'Welcome to the EMP',
    },
    pt: {
        quickAction: 'Ação Rápida',
        listTeamLicenses: 'Lista de licenças associadas a este time',
        listTeamAdmins: 'Lista de administradores com acesso a este time',
        settings: 'Configurações',
        general: 'Geral',
        dashboard: 'Painel de Controle',
        accessLogs: 'Registros de Acesso',
        greeting: 'Bem vindo ao EMP',
        teams: 'Times',
        team: 'Time',
        manageTeams: 'Gerenciar Times',
        teamProfile: 'Perfil do Time',
        teamList: 'Lista de times',
        teamListFor: 'Lista de times para',
    },
    es: {
        quickAction: 'Acción Rápida',
        listTeamLicenses: 'Lista de licencias asociadas a este equipo',
        listTeamAdmins: 'Lista de administradores con acceso a este equipo',
        settings: 'Configuraciones',
        general: 'General',
        dashboard: 'Tablero',
        accessLogs: 'Registros de acceso',
        greeting: 'Bienvenido al EMP',
    },
    fr: {
        quickAction: 'Action rapide',
        listTeamLicenses: 'Liste des licences associées à cette entreprise',
        listTeamAdmins: 'Liste des administrateurs ayant accès à cette entreprise',
        settings: 'Paramètres',
        general: 'Général',
        dashboard: 'Tableau de bord',
        accessLogs: 'Journaux d\'accès',
        greeting: 'Bienvenue dans l\'EMP',
    }
}

const associations = {
    en: {
        associationStatus: 'Association Status',
        associationOpen: 'Open',
        associationClosed: 'Closed',
        enableClosedComms: 'Enable Close Communications',
        selectAssociation: 'Choose an Association',
        availableAssociations: 'Available associations',
        associationList: 'Company Associations',
        associations: 'Associations',
        listTeamConnections: 'List of companies to which connections are allowed',
        manageAssociations: 'Manage Company Associations',
        createAssociation: 'Create Association',
        editAssociation: 'Edit Association',
        noTeamsAvailable: 'No Companies Available',
        noAssociationsAvailable: 'No Associations Available',
        deleteAssociation: 'Delete Association',
    },
    pt: {
        associationStatus: 'Status de Associação',
        associationOpen: 'Aberta',
        associationClosed: 'Fechada',
        enableClosedComms: 'Ativar Comunicação Fechada',
        selectAssociation: 'Selecione uma Associação',
        availableAssociations: 'Associações disponíveis',
        associationList: 'Associações entre times',
        associations: 'Associações',
        listTeamConnections: 'Lista de times a quem conexões são permitidas',
        manageAssociations: 'Gerenciar Associação de Times',
        createAssociation: 'Criar Associação',
        editAssociation: 'Editar Associação',
        noTeamsAvailable: 'Não há times disponíveis',
        noAssociationsAvailable: 'Não há associações disponíveis',
        deleteAssociation: 'Remover Associação',
    },
    es: {
        associationStatus: 'Estado de la asociación',
        associationOpen: 'Abierta',
        associationClosed: 'Cerrada',
        enableClosedComms: 'Habilitar comunicaciones cerradas',
        selectAssociation: 'Elegir una asociación',
        availableAssociations: 'Asociaciones disponibles',
        associationList: 'Asociaciones de equipo',
        associations: 'Asociaciones',
        listTeamConnections: 'Lista de equipos a los que se permiten conexiones',
        manageAssociations: 'Gestionar asociaciones de equipos',
        createAssociation: 'Crear asociación',
        editAssociation: 'Editar asociación',
        noTeamsAvailable: 'No hay equipos disponibles',
        noAssociationsAvailable: 'No hay asociaciones disponibles',
        deleteAssociation: 'Eliminar asociación',
    },
    fr: {
        associationStatus: 'Statut de l\'association',
        associationOpen: 'Ouverte',
        associationClosed: 'Fermée',
        enableClosedComms: 'Activer les communications fermées',
        selectAssociation: 'Choisir une association',
        availableAssociations: 'Associations disponibles',
        associationList: 'Associations d\'entreprises',
        associations: 'Associations',
        listTeamConnections: 'Liste des entreprises auxquelles les connexions sont autorisées',
        manageAssociations: 'Gérer les associations d\'entreprises',
        createAssociation: 'Créer une association',
        editAssociation: 'Modifier l\'association',
        noTeamsAvailable: 'Aucune entreprise disponible',
        noAssociationsAvailable: 'Aucune association disponible',
        deleteAssociation: 'Supprimer l\'association',
    }
}

const appSettings = {
    en: {
        apps: 'Applications',
        appSettings: 'Application Management',
        androidSettings: 'Android Settings',
        ecsSettings: 'ECS Settings',
        iosSettings: 'iOS Settings',
        windowsSettings: 'Windows Settings',
        macosSettings: 'macOS Settings',
        linuxSettings: 'Linux Settings',
        coreVersion: 'Core Version',
        minVersion: 'Minimum Supported Version',
        currentVersion: 'Last Released Version',
        storeURL: 'URL Download Path',
    },
    pt: {
        apps: 'Aplicativos',
        appSettings: 'Gerenciamento dos Aplicativos',
        androidSettings: 'Configuração Android',
        ecsSettings: 'Configuração ECS',
        iosSettings: 'Configuração iOS',
        windowsSettings: 'Configuração Windows',
        macosSettings: 'Configuração macOS',
        linuxSettings: 'Configuração Linux',
        coreVersion: 'Versão Core',
        minVersion: 'Versão Mínima Suportada',
        currentVersion: 'Última Versão Lançada',
        storeURL: 'URL Para Baixar',
    },
    es: {
        apps: 'Aplicaciones',
        appSettings: 'Gestión de aplicaciones',
        androidSettings: 'Configuraciones de Android',
        ecsSettings: 'Configuraciones de ECS',
        iosSettings: 'Configuraciones de iOS',
        windowsSettings: 'Configuraciones de Windows',
        macosSettings: 'Configuraciones de macOS',
        linuxSettings: 'Configuraciones de Linux',
        coreVersion: 'Versión Core',
        minVersion: 'Versión mínima compatible',
        currentVersion: 'Última versión lanzada',
        storeURL: 'Ruta de descarga de URL',
    },
    fr: {
        apps: 'Applications',
        appSettings: 'Gestion des applications',
        androidSettings: 'Paramètres Android',
        ecsSettings: 'Paramètres ECS',
        iosSettings: 'Paramètres iOS',
        windowsSettings: 'Paramètres Windows',
        macosSettings: 'Paramètres macOS',
        linuxSettings: 'Paramètres Linux',
        coreVersion: 'Version Core',
        minVersion: 'Version minimale prise en charge',
        currentVersion: 'Dernière version publiée',
        storeURL: 'Chemin de téléchargement URL',
    }
}

const passwordReset = {
    en: {
        choosePword: 'Please choose a password:',
        chooseNewPword: 'Please choose a new password:',
        pwordReset: 'Reset Password',
        changePword2: 'Or request password reset e-mail',
        changePword3: 'Send Password Reset E-mail',
        changePword4: 'Request Password Reset E-mail',
        changePword5: 'will receive a password reset e-mail.',
        changePword6: 'The e-mail will be sent to',
    },
    pt: {
        choosePword: 'Por favor escolha uma senha:',
        chooseNewPword: 'Por favor escolha uma nova senha:',
        pwordReset: 'Redefinir Senha',
        changePword2: 'Ou solicitar envio de e-mail para redefinição',
        changePword3: 'Enviar E-mail para Redefinição de Senha',
        changePword4: 'Solicitar e-mail para redefinição de senha',
        changePword5: 'vai receber um e-mail para redefinição de senha.',
        changePword6: 'O e-mail será enviado para',
    },
    es: {
        choosePword: 'Por favor elija una contraseña:',
        chooseNewPword: 'Por favor elija una nueva contraseña:',
        pwordReset: 'Restablecer contraseña',
        changePword2: 'O solicite el envío de un correo electrónico para restablecer la contraseña',
        changePword3: 'Enviar correo electrónico de restablecimiento de contraseña',
        changePword4: 'Solicitar correo electrónico de restablecimiento de contraseña',
        changePword5: 'recibirá un correo electrónico para restablecer la contraseña.',
        changePword6: 'El correo electrónico se enviará a',
    },
    fr: {
        choosePword: 'Veuillez choisir un mot de passe :',
        chooseNewPword: 'Veuillez choisir un nouveau mot de passe :',
        pwordReset: 'Réinitialiser le mot de passe',
        changePword2: 'Ou demander un e-mail de réinitialisation de mot de passe',
        changePword3: 'Envoyer un e-mail de réinitialisation de mot de passe',
        changePword4: 'Demander un e-mail de réinitialisation de mot de passe',
        changePword5: 'recevra un e-mail de réinitialisation de mot de passe.',
        changePword6: 'L\'e-mail sera envoyé à',
    }
}

const profileInfo = {
    en: {
        city: 'City',
        institution: 'Institution',
        profile: 'Profile',
        profileFor: 'Profile for',
        profileDetails: 'Profile Details',
        createdOn: 'Created on',
        myProfile: 'My Profile',
        expiration: 'Expiration',
        lastSeen: 'Last seen online',
        ipAddr: 'IP Address',
        name: 'Name',
        description: 'Description',
        firstName: 'First Name',
        lastName: 'Last Name',
        username: 'Username',
        language: 'Language',
        country: 'Country',
        notes: 'Notes',
        financeContact: 'Finance Contact E-mail',
        opsContact: 'Operations Contact E-mail',
        supportContact: 'Support Contact E-mail',
        timezone: 'Time zone',
        location: 'Location',
        dateTime: 'Date/Time',
        role: 'Role',
        access: 'Access level',
    },
    pt: {
        city: 'Cidade',
        institution: 'Instituição',
        profile: 'Perfil',
        profileFor: 'Perfil de',
        profileDetails: 'Detalhes do Perfil',
        createdOn: 'Criado em',
        myProfile: 'Meu Perfil',
        expiration: 'Expiração',
        lastSeen: 'Último acesso',
        ipAddr: 'Endereço IP',
        name: 'Nome',
        description: 'Descrição',
        firstName: 'Nome',
        lastName: 'Sobrenome',
        username: 'Usuário',
        language: 'Idioma',
        country: 'País',
        notes: 'Observações',
        financeContact: 'E-mail do Contato Financeiro',
        opsContact: ' E-mail do Contato de Operações',
        supportContact: ' E-mail do Contato de Suporte',
        timezone: 'Fuso-horário',
        location: 'Localização',
        dateTime: 'Data/Hora',
        role: 'Papel',
        access: 'Nível de acesso',
    },
    es: {
        city: 'Ciudad',
        institution: 'Institución',
        profile: 'Perfil',
        profileFor: 'Perfil para',
        profileDetails: 'Detalles del perfil',
        createdOn: 'Creado en',
        myProfile: 'Mi perfil',
        expiration: 'Expiración',
        lastSeen: 'Visto por última vez',
        ipAddr: 'Dirección IP',
        name: 'Nombre',
        description: 'Descripción',
        firstName: 'Nombre de pila',
        lastName: 'Apellido',
        username: 'Nombre de usuario',
        language: 'Idioma',
        country: 'País',
        notes: 'Notas',
        financeContact: 'E-mail Contacto financiero',
        opsContact: ' E-mail Contacto de operaciones',
        supportContact: ' E-mail Contacto de soporte',
        timezone: 'Zona horaria',
        location: 'Ubicación',
        dateTime: 'Fecha/Hora',
        role: 'Rol',
        access: 'Nivel de acceso',
    },
    fr: {
        city: 'Ville',
        institution: 'Institution',
        profile: 'Profil',
        profileFor: 'Profil pour',
        profileDetails: 'Détails du profil',
        createdOn: 'Créé le',
        myProfile: 'Mon profil',
        expiration: 'Expiration',
        lastSeen: 'Dernière connexion',
        ipAddr: 'Adresse IP',
        name: 'Nom',
        description: 'Description',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        username: 'Nom d\'utilisateur',
        language: 'Langue',
        country: 'Pays',
        notes: 'Notes',
        financeContact: 'E-mail du contact financier',
        opsContact: 'E-mail du contact opérationnel',
        supportContact: 'E-mail du contact support',
        timezone: 'Fuseau horaire',
        location: 'Emplacement',
        dateTime: 'Date/Heure',
        role: 'Rôle',
        access: 'Niveau d\'accès',
    }
}

const admins = {
    en: {
        resendConfirmation: 'Re-send confirmation',
        licenseActivationSuccessful: 'License activated successfully!',
        insertActivationToken: 'Insert Activation Token',
        validToken: 'Valid Token',
        testToken: 'Validate Token',
        invalidToken: 'Invalid Token',
        superAdmin: 'Super Admin',
        administrators: 'Administrators',
        admin: 'Admin',
        adminList: 'Admin List',
        adminProfile: 'Admin Profile',
        manageAdmins: 'Manage Admins',
        createLicenseSuccessful: 'License purchased successfully!',
        createTeam: 'Create Company',
        createTeamSuccessful: 'Company Created Successfully!',
        createTeamInfo: 'Company Information',
        createAdmin: 'Create Administrator',
        createAdminFill: 'Please fill in information below',
        createAdminSuccessful: 'Admin User Created Successfully!',
        createAdminInfo: 'Admin information',
        createAdminAsSuperAdmin: 'Create as Super-Admin?',
        createAdminAssignedTeams: 'Assigned Companies',
        createAdminRegistrationMethod: 'Registration Method',
        createAdminTooltip: `
        <b>Define password</b> - the admin user will be automatically activated.<br /> <br />
        <b>Send invite via e-mail (when emailing is enabled)</b> - the created admin will have to manually
        activate the account by clicking on the link sent to the chosen e-mail address.`,
        createAdminSendInvite: ' Send Invite via Email',
        createAdminDefinePword: 'Define Password',
        chooseTeam: 'Choose the company to which you want to add licenses',
        teams: 'Companies',
        team: 'Company',
        manageTeams: 'Manage Companies',
        teamProfile: 'Company Profile',
        teamList: 'Company List',
        teamListFor: 'Company list for',
    },
    pt: {
        resendConfirmation: 'Reenviar confirmação',
        licenseActivationSuccessful: 'Licença ativada com sucesso!',
        insertActivationToken: 'Insira o Token de Ativação',
        validToken: 'Token Válido',
        testToken: 'Validar Token',
        invalidToken: 'Token Inválido',
        superAdmin: 'Super Administrador',
        administrators: 'Administradores',
        admin: 'Administrador',
        adminList: 'Lista de Administradores',
        adminProfile: 'Perfil do Administrador',
        manageAdmins: 'Gerenciar Administradores',
        createTeam: 'Criar Time',
        createTeamInfo: 'Informação sobre o time',
        createTeamSuccessful: 'Time criado com sucesso!',
        createLicenseSuccessful: 'Licença adquirida com sucesso!',
        createAdmin: 'Criar Administrador',
        createAdminFill: 'Por favor preencha a informação abaixo',
        createAdminSuccessful: 'Usuário administrador criado com sucesso!',
        createAdminInfo: 'Informação do administrador',
        createAdminAsSuperAdmin: 'Create as Super-Admin?',
        createAdminAssignedTeams: 'Times gerenciados',
        createAdminRegistrationMethod: 'Método de registro',
        createAdminTooltip: `
        <b>Definir senha</b> - o administrador será ativado automaticamente.<br /> <br />
        <b>Enviar convite via e-mail (quando e-mails estão ativados)</b> - o administrador deverá manualmente ativar sua conta
        clicando no link enviado para o e-mail escolhido.`,
        createAdminSendInvite: 'Enviar convite via e-mail',
        createAdminDefinePword: 'Definir senha',
        chooseTeam: 'Escolha a empresa à qual você deseja adicionar licenças', 
    },
    es: {
        resendConfirmation: 'Reenviar confirmación',
        licenseActivationSuccessful: '¡Licencia activada con éxito!',
        insertActivationToken: 'Inserte el Token de Activación',
        validToken: 'Token Válido',
        testToken: 'Validar Token',
        invalidToken: 'Token Inválido',
        superAdmin: 'Super Administrador',
        administrators: 'Administradores',
        admin: 'Administrador',
        adminList: 'Lista de Administradores',
        adminProfile: 'Perfil del Administrador',
        manageAdmins: 'Gestionar Administradores',
        createLicenseSuccessful: '¡Licencia adquirida con éxito!',
        createTeam: 'Crear equipo',
        createTeamSuccessful: '¡Equipo creado con éxito!',
        createTeamInfo: 'Información del equipo',
        createAdmin: 'Crear administrador',
        createAdminFill: 'Por favor complete la información a continuación',
        createAdminSuccessful: '¡Usuario administrador creado con éxito!',
        createAdminInfo: 'Información del administrador',
        createAdminAsSuperAdmin: '¿Crear como Super-Admin?',
        createAdminAssignedTeams: 'Equipos asignados',
        createAdminRegistrationMethod: 'Método de registro',
        createAdminTooltip: `
            <b>Definir contraseña</b> - el usuario administrador será activado automáticamente.<br /> <br />
            <b>Enviar invitación por correo electrónico (cuando se habilitan los correos electrónicos)</b> - el administrador creado deberá activar manualmente la cuenta haciendo clic en el enlace enviado a la dirección de correo electrónico elegida.`,
        createAdminSendInvite: 'Enviar invitación por correo electrónico',
        createAdminDefinePword: 'Definir contraseña',
        chooseTeam: 'Elige la empresa a la que deseas agregar licencias',
        teams: 'Equipos',
        team: 'Equipo',
        manageTeams: 'Gestionar equipos',
        teamProfile: 'Perfil del equipo',
        teamList: 'Lista de equipos',
        teamListFor: 'Lista de equipos para',
    },
    fr: {
        resendConfirmation: 'Renvoyer la confirmation',
        licenseActivationSuccessful: 'Licence activée avec succès !',
        insertActivationToken: 'Insérer le jeton d\'activation',
        validToken: 'Jeton valide',
        testToken: 'Valider le jeton',
        invalidToken: 'Jeton invalide',
        superAdmin: 'Super administrateur',
        administrators: 'Administrateurs',
        admin: 'Administrateur',
        adminList: 'Liste des administrateurs',
        adminProfile: 'Profil administrateur',
        manageAdmins: 'Gérer les administrateurs',
        createLicenseSuccessful: 'Licence achetée avec succès !',
        createTeam: 'Créer une entreprise',
        createTeamSuccessful: 'Entreprise créée avec succès !',
        createTeamInfo: 'Informations sur l\'entreprise',
        createAdmin: 'Créer un administrateur',
        createAdminFill: 'Veuillez remplir les informations ci-dessous',
        createAdminSuccessful: 'Administrateur créé avec succès !',
        createAdminInfo: 'Informations administrateur',
        createAdminAsSuperAdmin: 'Créer en tant que super-administrateur ?',
        createAdminAssignedTeams: 'Entreprises assignées',
        createAdminRegistrationMethod: 'Méthode d\'inscription',
        createAdminTooltip: `
        <b>Définir le mot de passe</b> - l\'administrateur sera automatiquement activé.<br /> <br />
        <b>Envoyer une invitation par e-mail (quand les e-mails sont activés)</b> - l\'administrateur créé devra manuellement
        activer le compte en cliquant sur le lien envoyé à l\'adresse e-mail choisie.`,
        createAdminSendInvite: ' Envoyer une invitation par e-mail',
        createAdminDefinePword: 'Définir le mot de passe',
        chooseTeam: 'Choisissez l\'entreprise à laquelle vous voulez ajouter des licences',
        teams: 'Entreprises',
        team: 'Entreprise',
        manageTeams: 'Gérer les entreprises',
        teamProfile: 'Profil de l\'entreprise',
        teamList: 'Liste des entreprises',
        teamListFor: 'Liste des entreprises pour',
    }
}

export const messages = {
    en: {
        ...dashboard.en,
        ...licenses.en,
        ...domains.en,
        ...invites.en,
        ...teams.en,
        ...responseMessages.en,
        ...yup.en,
        ...users.en,
        ...general.en,
        ...settings.en,
        ...publicKeys.en,
        ...headers.en,
        ...actionsStatus.en,
        ...associations.en,
        ...appSettings.en,
        ...passwordReset.en,
        ...profileInfo.en,
        ...admins.en,
    },
    pt: {
        ...dashboard.pt,
        ...domains.pt,
        ...invites.pt,
        ...licenses.pt,
        ...teams.pt,
        ...responseMessages.pt,
        ...yup.pt,
        ...users.pt,
        ...general.pt,
        ...settings.pt,
        ...publicKeys.pt,
        ...headers.pt,
        ...actionsStatus.pt,
        ...associations.pt,
        ...appSettings.pt,
        ...passwordReset.pt,
        ...profileInfo.pt,
        ...admins.pt,
    },
    es: {
        ...dashboard.es,
        ...domains.es,
        ...invites.es,
        ...licenses.es,
        ...teams.es,
        ...responseMessages.es,
        ...yup.es,
        ...users.es,
        ...general.es,
        ...settings.es,
        ...publicKeys.es,
        ...headers.es,
        ...actionsStatus.es,
        ...associations.es,
        ...appSettings.es,
        ...passwordReset.es,
        ...profileInfo.es,
        ...admins.es,
    },
    fr: {
        ...dashboard.fr,
        ...licenses.fr,
        ...domains.fr,
        ...invites.fr,
        ...teams.fr,
        ...responseMessages.fr,
        ...yup.fr,
        ...users.fr,
        ...general.fr,
        ...settings.fr,
        ...publicKeys.fr,
        ...headers.fr,
        ...actionsStatus.fr,
        ...associations.fr,
        ...appSettings.fr,
        ...passwordReset.fr,
        ...profileInfo.fr,
        ...admins.fr,
    }
};